<template>
    <div>
        <b-loading :is-full-page="false" :active.sync="loadingTags" :can-cancel="true"></b-loading>
        <p class="title heading has-text-centered">Productos mencionados en esta entrada</p>
        <b-carousel-list 
        v-model="model" 
        :data="tags" 
        :items-to-show="2">
            <template slot="item" slot-scope="props">
                <a target="_blank" :href="props.list.productObj.getDetailUrl" >
                    <div class="card">
                        <div class="card-image has-text-centered">
                            <div class="img-overlay">
                                <div class="img-overlay-btn">
                                    <b-button
                                    class="is-custom"
                                    rounded>
                                    <b-icon icon="eye" size="is-small"></b-icon>
                                    Ver producto                            
                                    </b-button>
                                </div>
                            </div>
                            <div v-if="props.list.productObj.status == 'O'" class="tag is-danger is-rounded sale-tag">
                                Oferta
                            </div>
                            <img :src="props.list.productObj.getImage" alt="imagen-subcategoria">
                        </div>
                        
                        <div class="card-content">
                            <div class="content product-content">
                                <p class="has-text-weight-semibold has-text-centered">{{props.list.productObj.title}}</p>
                                <div class="price has-text-centered">
                                    <p  style="text-decoration: line-through; color:#333;"  v-if="props.list.productObj.status=='O'">
                                        {{props.list.productObj.currencySymbol}} {{props.list.productObj.compareAt}}
                                    </p>
                                    <p class="has-text-custom ">{{props.list.productObj.currencySymbol}} {{props.list.productObj.price}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    </a>
            </template>
        </b-carousel-list>
    </div>
</template>

<script>
export default {
    props:{
        tags:{
            type:Array,
            default: new Array([])
        },
        loadingTags:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            model:0
        }
    }
}
</script>

<style lang="scss" scoped>
.section-img{
        max-width:200px;
    }

    .section-title{
        color: var(--primary);
    }

    .card{
        height:100%;
        border:0px #fff solid !important;
        box-shadow: 0px 0px 0px 0px #b8b8b8;
        transition: all 1s;
    }
    a:hover {
        .card{
            box-shadow: 1px 10px 10px #b8b8b8;
            .card-image{
                img{
                    transform: scale(1.1);
                }
                .img-overlay{
                    opacity: 1;
                }
            }
        }
    }
    .card-image{
        overflow: hidden;
        img{
            max-height: 200px;
            transition: all 3s;
        }
    }
    .card-content{
        padding:5px;
    }
    .product-content{
        margin: 0px;
        p{
            margin:0px;
            padding:0px;
        }
    }

    .sale-tag{
        position:absolute;
        left:5px;
        top:5px;
        z-index:10;
    }
    .img-overlay{
        position:absolute;
        opacity:0;
        z-index:10;
        width:100%;
        height:100%;
        background: rgba(0, 0, 0, 0.2);
        transition: opacity 0.5s ease-in;
    }

    .img-overlay-btn{
        position: absolute;
        bottom: 20px;;
        left: 0;
        width: 100%;
    }

    .is-custom{
        background-color: var(--primary);
        color: var(--text-color);
    }

    .has-text-custom{
        color: var(--primary)
    }

</style>